<template>
  <div>
    <PageHero position="SERVICE" :fallback="hero" />
    <ProcessSection />
    <section class="tinted"><div class="section about-split"><div><p class="eyebrow">AFTER-SALES SUPPORT</p><h2 class="pre-line">{{ $t('servicePage.title') }}</h2><p>{{ $t('servicePage.intro') }}</p><a class="large-phone" href="tel:075584049832">0755-84049832</a><p class="source-note">{{ $t('servicePage.note') }}</p></div><img :src="assets.factory" :alt="$t('servicePage.title')" class="wide-image"></div></section>
    <section class="section narrow"><SectionHeading eyebrow="FREQUENTLY ASKED QUESTIONS" :title="$t('servicePage.faqTitle')" /><details v-for="item in faqs" :key="item.q"><summary>{{ item.q }}</summary><p>{{ item.a }}</p></details></section>
    <ContactCta />
  </div>
</template>
<script>
import PageHero from '../components/PageHero.vue'
import ProcessSection from '../components/ProcessSection.vue'
import SectionHeading from '../components/SectionHeading.vue'
import ContactCta from '../components/ContactCta.vue'
import {assets} from '../data/site'
export default{name:'ServiceView',components:{PageHero,ProcessSection,SectionHeading,ContactCta},data(){return{assets}},computed:{hero(){return{eyebrow:'SERVICE & SUPPORT',title:this.$t('servicePage.heroTitle'),subtitle:this.$t('servicePage.heroSubtitle'),image:assets.team}},faqs(){return[1,2,3,4].map(number=>({q:this.$t(`servicePage.q${number}`),a:this.$t(`servicePage.a${number}`)}))}}}
</script>
